import { Directive, ElementRef, HostListener, Input, OnChanges } from '@angular/core';
import { environment } from '@environment';

@Directive({
    selector: '[appToggleInput]',
    standalone: true
})
export class ToggleInputDirective implements OnChanges {

    @Input() form: any;
    @Input() field: any;
    previous_value: any;
    @Input() update: boolean;
    edit_pen = environment.DEPLOY_URL + '/assets/images/edit_pen_black.svg';
    cancelled = environment.DEPLOY_URL + '/assets/images/cancelled.svg'

    constructor(private el: ElementRef) {
        this.el.nativeElement.style.cursor = 'pointer';
    }

    @HostListener('click', []) onClick() {
        this.el.nativeElement.src = this.el.nativeElement.src.includes(this.cancelled) ? this.edit_pen : this.cancelled;
        const field = this.form.get(this.field);
        if (field.value !== undefined) {
            this.previous_value = JSON.parse(JSON.stringify(field.value));
        }

        if (field.status === 'DISABLED') {
            field.enable();
        } else {
            field.patchValue(this.previous_value);
            field.disable();
        }
    }

    ngOnChanges() {
        if (this.update) {
            this.el.nativeElement.src = this.edit_pen;
            this.form.get(this.field).disable();
        }
    }
}
